import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Prospects from "@/pages/Prospects";
import Proposal from "@/pages/Proposal";
import Demo from "@/pages/Demo";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/strumenti" element={<Prospects />} />
      <Route path="/proposta/:prospectId" element={<Proposal />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error(error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            background: "#0E0C0B",
            color: "#F5F2EB",
            padding: 24,
            textAlign: "center",
          }}
        >
          <div>
            <p className="font-serif text-2xl">Qualcosa è andato storto.</p>
            <button
              data-testid="error-reload-button"
              className="mt-4 rounded-full border border-line px-6 py-2 font-accent text-xs uppercase tracking-[0.2em] text-terracotta"
              onClick={() => window.location.reload()}
            >
              Ricarica la pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" }), 350);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 1 }}>
        <BrowserRouter>
          <ScrollToTop />
          <AppRoutes />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </ReactLenis>
    </ErrorBoundary>
  );
}

export default App;